<template>

  <div class="activities-overlay">
    <div class="top-bar">
      <button class="btn back-button" v-on:click="backClicked"><span></span></button>
      <div class="title-bar">
        <div class="icon" :class="questTypeOutlinedIconClass(questType)"></div>
        <div class="title">{{ questTypeToString(questType) }}</div>
      </div>
    </div>

    <transition appear name="bounce">
      <div v-show="open" class="activities-list-wrapper">
        <div class="header-bar"></div>

        <ActivityList :selectedBuddy="buddy" :questType="questType" :currentActivities="currentActivities" :open="open"
                      @questClicked="questClicked"></ActivityList>
      </div>
    </transition>
  </div>

</template>

<script>


import ActivityList from "@/components/StudentPlatform/Activities/ActivityList";
import QuestTypeHelper from "@/mixins/QuestTypeHelper";
import {ActivityType} from "@/enums/ActivityType";

export default {
  name: "ActivitiesOverlay",
  components: {ActivityList},
  inject: ["doApiRequest"],
  mixins: [QuestTypeHelper],
  props: {
    name: String,
    open: Boolean,
    buddy: Object,
    questType: String,
    currentActivities: Array,
  },
  watch: {},
  data() {
    return {
      show: this.open,
      quests: [],
      selectedBuddy: null
    }
  },
  computed: {
    getColor() {
      let color = "";
      switch (this.name) {
        case ActivityType.MORE:
          color = "rgb(255,90,49)";
          break;
        case ActivityType.SMART:
          color = "rgb(0,185,255)";
          break;
        case ActivityType.TOGETHER:
          color = "rgb(159,220,96)";
          break;
        case ActivityType.IMPULSE:
          color = "rgb(253,132,255)";
          break;
      }
      return color;
    },
    getName() {
      let title = "";
      switch (this.name) {
        case ActivityType.MORE:
          title = "Beweeg Meer";
          break;
        case ActivityType.SMART:
          title = "Beweeg Slim";
          break;
        case ActivityType.TOGETHER:
          title = "Beweeg Samen";
          break;
        case ActivityType.IMPULSE:
          title = "Beweeg Tussendoor";
          break;
      }
      return title;
    },
  },
  methods: {

    backClicked() {
      this.$emit("backClicked", this.questType === 'impulse');
    },

    questClicked(id) {
      this.$emit("questClicked", id);
    },

  },
  mounted() {

  },
  created() {

  },
}


</script>

<style lang="scss" scoped>

@mixin aspect-ratio($width, $height) {
  position: relative;
  &:before {
    display: block;
    content: "";
    width: 100%;
    padding-top: ($height / $width) * 100%;
  }
  > .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

.activities-overlay {
  width: 100vw;
  height: 100vh;
  position: absolute;
  background-color: rgb(37, 38, 66);
  z-index: 1;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.top-bar {
  height: 150px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.activities-list-wrapper {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  background-image: url("~@/assets/image/platform/background/activity_bg.svg");
  background-position: center;

  .header-bar {
    width: 100%;
    background-image: url("~@/assets/image/platform/background/activity_border.svg");
    background-repeat: no-repeat;
    background-size: 100vw;
    background-position: top center;
    padding-top: 6%;
    pointer-events: none;
  }
}

.back-button {
  width: 100px;
  height: 100px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 50px;
  top: 25px;
  background-image: url("~@/assets/image/button/bb_button_square.svg");

  span {
    display: block;
    width: 70%;
    height: 70%;
    background-image: $back-icon;
    background-position: center;
    background-size: contain;
  }

}

.title-bar {
  min-height: 67%;
  width: 600px;
  margin-bottom: 15px;
  position: relative;
  background-image: url("~@/assets/image/bb_frame-title.svg");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;

  display: flex;
  align-items: center;


  .icon {
    position: absolute;
    width: 60px;
    height: 60px;
    left: 20px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    background-color: transparent;

    &.more {
      background-image: url("~@/assets/image/platform/activities/bb_icon-beweeg_meer.svg");
    }

    &.smart {
      background-image: url("~@/assets/image/platform/activities/bb_icon-beweeg_slim.svg");
    }

    &.together {
      background-image: url("~@/assets/image/platform/activities/bb_icon-beweeg_samen.svg");
    }

    &.impulse {
      background-image: url("~@/assets/image/platform/activities/bb_icon-beweeg_tussendoor.svg");
    }
  }

  .title {
    align-self: center;
    margin: 0px 100px;
    width: 100%;
    text-align: center;
    font-weight: bold;
    font-size: 2rem;
    color: white;
  }
}


.bounce-enter-active {
  animation: bounce-in 1s;
}

.bounce-leave-active {
  animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: translateY(100vh);
  }
  50% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(0);
  }
}

</style>